import axios, { AxiosInstance } from 'axios';
import { authorizationHeaderInterceptor } from './interceptors/request/authorization';
import baseURLInterceptor from './interceptors/request/baseURL';
import { setupRefreshTokenInterceptor } from './interceptors/request/refresh-token';

export const httpClient: AxiosInstance = (() => {
    const instance = axios.create();

    // Override base URL
    instance.interceptors.request.use(
        // @ts-expect-error - TypeScript is complaining about the config type, but it is correct according to Axios documentation
        baseURLInterceptor,
        (error) => Promise.reject(error)
    );
    // Inject Bearer token
    instance.interceptors.request.use(
        // @ts-expect-error - TypeScript is complaining about the config type, but it is correct according to Axios documentation
        authorizationHeaderInterceptor,
        (error) => Promise.reject(error)
    );

    // Handle 401 responses with token refresh
    setupRefreshTokenInterceptor(instance);

    return instance;
})();

window.HttpClient = httpClient;
